<template>
  <div class="language-switcher">
    <div
      v-for="locale in $i18n.availableLocales"
      :key="locale"
      class="language-switcher-item"
      :class="{ 'is-active': locale === $i18n.locale }"
      @click="$i18n.locale = locale"
    >
      {{ locale }}
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.language-switcher {
  display: flex;
}

.language-switcher-item {
  width: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-right: 2px solid #000;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:first-child {
    border-left: 2px solid #000;
  }

  @media (max-width: 640px) {
    &:last-child {
      border-right: none;
    }
  }

  &.is-active {
    background: #6d00cf !important;
    color: #fff;
  }

  &:hover {
    background: #00a0a4;
    color: #fff;
  }
}
</style>
